export default "__VITE_ASSET__CbvhowNY__"